export enum EnvironmentName {
    PROD = 'prod',
    BETA = 'beta',
    DEV = 'dev'
}
